import React, { memo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import { aigcReplyIsBusing } from '../../../../actions/aigc';

export default memo(({ styles, answerItem }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(aigcReplyIsBusing({ isBusing: 5 }));
  }, []);

  return <span className={styles.chat}>{answerItem?.commandMsg?.tip}</span>;
});
